// import * as reconnectGuideTypes from '../consts/app/reconnectGuideTypes';
// import ModalTypes from '../enums/app/modalTypes';
// import {setDiagnosticFlowDataResult, setIsDiagnosticFlow} from '../state/ducks/advancedDiagnostic';
// import {removeGamAuthData, setFetchTokenInProgress} from '../state/ducks/auth';
// import {removeConsumerProductsStatus} from '../state/ducks/consumer';
// import {
//     hideAllLoaders,
//     setHolderRegisterFailed,
//     setIsAemFlexBatteryWarningVisible,
//     setIsRegistrationWas,
//     setIsSkipRegistration,
//     setIsStartAutoSync,
//     setScpCheckInProgress,
// } from '../state/ducks/global';
// import {
//     clearIotDevice,
//     clearIotDeviceHolderData,
//     setDeviceActivationStatus,
//     setFWUCheking,
//     setIsDisconnected,
//     setIsPairingInProgress,
// } from '../state/ducks/iotDevice/actions';
// import {hideModalAction, showReconnectDeviceGuideModalAction} from '../state/ducks/modal';
// import {clearMwDevice, setMwDeviceIsDisconnectedWithNoReconnect} from '../state/ducks/mwDevice';
// import {clearProductsToChangeRegistrationStatus} from '../state/ducks/productSettings';
// import {clearHolderAssetUsage, clearUsageStats} from '../state/ducks/usageStatistic';
// import {
//     clearYapAssets,
//     setDataCollectionLastRequestId,
//     setDeviceInfoReceived,
//     setHolderInfoReceived,
//     setIsYapUsageFlow,
//     setOfflineYapFirmwareInProgress,
//     setSyncLastRequestId,
//     setYapActivationInProgress,
//     setYapFirmwareInProgress,
//     setYapHolderConnected,
//     setYapLastRequestId,
//     setYapSyncInProgress,
//     setYapUpdateSettingsInProgress,
// } from '../state/ducks/yapEncrypted';
// import {selectIotDeviceType, selectIsDeviceConnected} from '../state/selectors/iotDevice';
// import {
//     makeSelectAssetByType,
//     makeSelectIsYapAutoCleaningInProgress,
//     makeSelectIsYapFirmwareInProgress,
//     makeSelectIsYapResetInProgress,
// } from '../state/selectors/yapEncrypted';
// import {dispatch, getState} from '../state/store';
// import analyticsService from './analyticsService';
// import backendService from './app/backendService';
// import authDataStoreService from './auth/authDataStoreService';
// import cmClientService from './communicationLayer/cmClientService';
// import cmMessageRequestService from './communicationLayer/cmMessageRequestService';
import deviceIdlePingScheduler from './device/deviceIdlePingScheduler';
import devicePreSyncPingScheduler from './device/devicePreSyncPingScheduler';
import framesProcessingService from './device/framesProcessingService';
import {getIqosService} from './device/iqosServiceClient';
import deviceCharacteristicService from './ble/deviceCharacteristicService';
import connectivityService from './device/connectivityService';
import uamFlowService from './uam/uamFlowService';
import {resetMwState} from '../state/slices/mwDevice';
import {resetIotState} from '../state/slices/iotData';
import {resetUamState} from '../state/slices/uamData';
import cmClientService from './communicationLayer/cmClientService';
import iotWebSocketService from './websocket/iotWebSocketService';
// import deviceConnectionDetectorService from './deviceConnectionDetectorService';
// import DisconnectEventEmitter from './events/disconnectEventEmitter';
// import hidReconnectHandlerService from './hid/hidReconnectHandlerService';
// import log from './logger/log';
// import productService from './product/productService';
// import appRouterService from './route/appRouterService';
// import * as dataCollectionService from './uam/dataCollectionService';
// import userDeviceService from './user/userDeviceService';
// import yapWebSocketService from './yap/yapWebSocketService';

// const onAvailabilityChanged = (e) => {
//     const isEnabled = e.target.value;

//     log.info(`iqosBleService: onAvailabilityChanged, isEnabled: ${isEnabled}`);

//     if (isEnabled) return;

//     const isDeviceConnected = selectIsDeviceConnected(getState());

//     if (isDeviceConnected) {
//         dispatch(showReconnectDeviceGuideModalAction({guideType: reconnectGuideTypes.CRITICAL}));
//     }

//     appRouterService.forwardToMyDevicesPage();
//     //IA: exactly order that is needed
//     //    first forward
//     //    than clearDevice
//     disconnectAndClearState();
//     dispatch(hideAllLoaders());
// };

// const addBleAvailabilityListener = () => {
//     if (!userDeviceService.isBluetoothEventListenersSupported()) return;

//     navigator.bluetooth.removeEventListener('availabilitychanged', onAvailabilityChanged);
//     navigator.bluetooth.addEventListener('availabilitychanged', onAvailabilityChanged);
// };

const disconnectIqosClient = () => {
    const iqosService = getIqosService();

    if (iqosService.isClientInitialized()) {
        iqosService.disconnect();
    }
};

export const disconnectAndClearState = () => {
    disconnectIqosClient();
    clearState();
    //     productService.clearConsumerLinkAttempt();
    //     hidReconnectHandlerService.clearHidReconnectHandlerState();
    //     dispatch(hideModalAction(ModalTypes.QUICK_START_GUIDE_POPUP));
    //     dispatch(setIsPairingInProgress(false));
};

const clearState = () => {
    cmClientService.disconnectCmClient();
    iotWebSocketService.disconnectWebSocket();
    resetMwState();
    resetIotState();
    resetUamState();
    uamFlowService.clearAllFlows();
};

// const disconnectAndForwardToMyDevicesPage = (isDeviceDisconnected) => {
//     if (!isDeviceDisconnected) {
//         disconnectAndClearState();
//     }

//     dispatch(hideModalAction(ModalTypes.HID_RECONNECT));
//     appRouterService.forwardToMyDevicesPage();
// };

// const disconnectAndShowCriticalGuide = () => {
//     const type = selectIotDeviceType(getState());

//     analyticsService.pushGeneralDeviceReconnectionErrorEvent(type);
//     disconnectAndForwardToMyDevicesPage();
//     dispatch(hideModalAction(ModalTypes.RECONNECT_DEVICE_GUIDE));
//     dispatch(showReconnectDeviceGuideModalAction({guideType: reconnectGuideTypes.CRITICAL}));
// };

// const onPairingError = () => disconnectAndClearState();

const stopDeviceSchedulers = () => {
    framesProcessingService.disable();
    devicePreSyncPingScheduler.stopPing();
    deviceIdlePingScheduler.killScheduler();
};

const onDeviceDisconnect = (isForceDisconnected) => {
    //     const state = getState();
    //     const isDeviceConnected = selectIsDeviceConnected(state);

    //     // do nothing if status of the device is not connected
    //     if (!isDeviceConnected) return;

    //     const disconnectEventEmitter = new DisconnectEventEmitter();

    //     disconnectEventEmitter.emitDisconnect({isForceDisconnected});

    //     if (isForceDisconnected) {
    //         dispatch(setMwDeviceIsDisconnectedWithNoReconnect(true));
    //     }

    stopDeviceSchedulers();

    const isUsb = connectivityService.isUsb();

    if (!isUsb) {
        deviceCharacteristicService.removeCharacteristicsListeners();
    }

    if (isForceDisconnected) {
        clearState();
    }

    //     if (!isForceDisconnected) {
    //         if (isUsb) {
    //             hidReconnectHandlerService.showHidReconnectModal();
    //         } else {
    //             deviceConnectionDetectorService.showFailedReconnectDeviceGuide();
    //         }
    //     }

    //     dispatch(setIsDisconnected());

    //     const isYapFirmwareInProgress = makeSelectIsYapFirmwareInProgress()(state);

    //     if (isYapFirmwareInProgress) {
    //         dispatch(setFWUCheking());
    //     } else {
    //         //a long timeout is assigned to cleaning when disconnect event is sent
    //         const isAutoCleanInProgress = makeSelectIsYapAutoCleaningInProgress()(state);
    //         //disconnect while reset fails reset flow on IoT
    //         const isYapResetInProgress = makeSelectIsYapResetInProgress()(state);

    //         if (!isAutoCleanInProgress && !isYapResetInProgress) {
    //             cmMessageRequestService.publishDisconnectEvent();
    //             cmMessageRequestService.publishDisconnectEvent(true);
    //         }
    //     }

    //     dataCollectionService.setDataCollectionFlowReceived();
    //     dataCollectionService.setDataCollectionFlowReceived({isHolder: true});
    //     dispatch(setDeviceInfoReceived(false));
    //     dispatch(setHolderInfoReceived(false));
};

const isDeviceConnected = () => {
    const iqosService = getIqosService();

    return iqosService.isDeviceConnected();
};

export default {
    // addBleAvailabilityListener,
    // disconnectAndClearState,
    // disconnectAndClearHolderState,
    // disconnectAndForwardToMyDevicesPage,
    // disconnectAndShowCriticalGuide,
    isDeviceConnected,
    onDeviceDisconnect,
    // onPairingError,
    stopDeviceSchedulers,
};
